import { render, staticRenderFns } from "./StorageWarningBanner.vue?vue&type=template&id=3462f488&"
import script from "./StorageWarningBanner.vue?vue&type=script&lang=js&"
export * from "./StorageWarningBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports